export default class VariantUpdater extends HTMLElement {
  #abortController
  #variantId
  #bundleIndex
  #groupIndex

  constructor({ variantId, quantity, image, options, customText, bundleIndex, groupIndex }) {
    super();
    const arr = options?.split('|') || [];
    const optionValues = arr[1]?.replaceAll(',', ' | ');
    //
    this.className = 'variant-updater';
    this.innerHTML = `
      <div class="variant-updater__info">
        ${optionValues}
      </div>

      <div class="variant-updater__row">
        <div class="variant-updater__image">
          <img src="${image}" width="52" height="52" loading="lazy">
        </div>

        <number-button 
          class="theme-button bundler-grid__items__grid-item__button bundler-grid__items__grid-item__button--quantity" 
          data-card-type="verticle" 
          data-value="${quantity}"
        >
          <button type="button" data-icon="minus"></button>
          <input 
            type="number"
            step="1"
            min="0"
            value="${quantity}"
            data-product-variant="${variantId}"
            name="update"
          >
          <button type="button" data-icon="plus"></button>
        </number-button>
      </div>
    `;
    this.numberBtn = this.querySelector('number-button');
    this.#variantId = variantId;
    this.#bundleIndex = bundleIndex;
    this.#groupIndex = groupIndex;
    this.quantity = quantity;
    this.dataset.quantity = quantity;
    this.dataset.variantId = variantId;
    this.dataset.bundleIndex = bundleIndex;
    //
    if (customText) {
      const arr = customText.split('|');
      const divs = [];
      arr?.forEach((value,i) => {
        divs.push(document.createElement('DIV'));
        /* divs[i].className = 'side-cart-main-item__options__container__item'; */
        divs[i].textContent = value;
        this.firstElementChild.append(...divs);
      });
    }
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.numberBtn.input.addEventListener('input', (e) => {
      if (e.target.valueAsNumber === 0) {
        this.#dispatchBundleStepEvent({ name: 'remove', data: { quantity: 0, variantId: this.#variantId, bundleIndex: this.#bundleIndex, groupIndex: this.#groupIndex } });
      } else {
        this.#dispatchBundleStepEvent({ name: 'update', data: { quantity: e.target.valueAsNumber, variantId: this.#variantId, bundleIndex: this.#bundleIndex, groupIndex: this.#groupIndex } });
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['data-quantity', 'data-max'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-quantity') {
      this.quantity = parseInt(newValue);
      this.numberBtn.dataset.value = newValue;
    }
    if (name === 'data-max') {
      this.numberBtn.input.setAttribute('max', newValue);
    }
  }

  #dispatchBundleStepEvent(detail, replace = false) {
    const event = new CustomEvent('bundlestep:event', {
      detail: {...detail, replace},
      bubbles: true
    });
    this.dispatchEvent(event);
  }

  
}

customElements.define('variant-updater', VariantUpdater);